import React, { useContext, useEffect } from 'react';
import Configurator from '../components/configurator/Configurator';
import WardrobeBodyConfigs from '../components/configurationOptions/WardrobeBodyConfigs';
import ProgressBar from '../components/ProgressBar';
import { ConfiguratorModeContext } from '../contexts/ConfiguratorModeContext';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';

const WardrobeBodyConfiguration = props => {
  const { dimensions, products } = props;
  const { setCurrentConfiguratorMode } = useContext(ConfiguratorModeContext);
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);

  const slidePoints = [];
  let activeSliding = false;
  let activeHinged = false;
  let doorBreakpoint = null;

  const wardrobe = wardrobesConfigs[activeWardrobe];
  const wardrobeSafo = wardrobe.safo.split('-').pop();
  if (products) {
    products.wardrobeHulls.forEach(item => {
      if (
        item.is_corner === false &&
        item.safo.includes(wardrobeSafo) &&
        wardrobe.dimensions.z === item.dimensions.z &&
        wardrobe.dimensions.y === item.dimensions.y
      ) {
        if (!slidePoints.includes(item.dimensions.x)) {
          slidePoints.push(item.dimensions.x);
        }
      }
    });
  }
  if (dimensions) {
    if (dimensions.width.hasOwnProperty(1)) {
      // @todo zablokownie naroznikow - szaf uchylnych
      activeHinged = true;
    }
    if (dimensions.width.hasOwnProperty(2)) {
      activeSliding = true;
      doorBreakpoint = dimensions.width[2][0];
    }
  }

  useEffect(() => {
    setCurrentConfiguratorMode(1);
    /* eslint-disable-next-line */
  }, []);

  return (
    <Configurator slidePoints={slidePoints} doorBreakpoint={doorBreakpoint}>
      <ProgressBar activeLvl={0} />
      <WardrobeBodyConfigs
        dimensions={dimensions}
        activeHinged={activeHinged}
        activeSliding={activeSliding}
      />
    </Configurator>
  );
};

export default WardrobeBodyConfiguration;
